module.exports = __webpack_public_path__ + "img/blueBottom.fc856fea.png";